// Predefined categories - mirrors the backend's validated list and order.
export interface CommunicationCategory {
    id: string;
    tone: string;
}

export const COMMUNICATION_CATEGORIES: readonly CommunicationCategory[] = [
    { id: 'Shipping', tone: '#7C6BEA' },
    { id: 'Case submission', tone: '#2C6F67' },
    { id: 'Case status', tone: '#3B82F6' },
    { id: 'Clinical', tone: '#0E9488' },
    { id: 'Billing', tone: '#D97706' },
    { id: 'Dashboard', tone: '#6B7280' },
    { id: 'Scheduling', tone: '#DB2777' },
    { id: 'Onboarding', tone: '#65A30D' },
    { id: 'Other', tone: '#9CA3AF' }
];

const DEFAULT_TONE = COMMUNICATION_CATEGORIES[COMMUNICATION_CATEGORIES.length - 1].tone;

export function categoryTone(id: string): string {
    return COMMUNICATION_CATEGORIES.find((c) => c.id === id)?.tone ?? DEFAULT_TONE;
}
